import React from 'react';
import {
  Box,
  Container,
  useTheme,
  alpha,
} from '@mui/material';
import EnhancedCentralSearchBar from '../EnhancedCentralSearchBar';

const HeroSection = () => {
  const theme = useTheme();

  return (
    <Box
      component="section"
      sx={{
        position: 'relative',
        overflow: 'hidden',
        background: `linear-gradient(135deg, ${theme.palette.primary.dark} 0%, ${theme.palette.primary.main} 50%, ${alpha(theme.palette.secondary.main, 0.7)} 100%)`,
        pt: { xs: 4, sm: 5, md: 6 },
        pb: { xs: 3, sm: 4, md: 5 },
        minHeight: { xs: 'auto', md: 240 },
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: { xs: 'auto', md: 180 } }}>
          <Box sx={{ maxWidth: 640, width: '100%', position: 'relative', zIndex: 1 }}>
            <EnhancedCentralSearchBar compact={true} />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
